import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'
require('es6-promise').polyfill()

const requestCount = new Map();
const errorMessage = new Set();

const MyAxios = axios.create({
    timeout: -1
})

MyAxios.interceptors.request.use(function (config) {
    if (!requestCount.has(location.pathname)) {
        requestCount.set(location.pathname, 1);
    } else {
        requestCount.set(location.pathname, requestCount.get(location.pathname) + 1);
    }
    config.headers['token'] = CookieManage.get("token")
    return config
}, function (error) {
    Message.warning('网络异常，请稍后再试！')
    return Promise.reject(error)
})

MyAxios.interceptors.response.use(function (response) {
    requestCount.set(location.pathname, requestCount.get(location.pathname) - 1);
    if (typeof(response.data.code)=='number') {
        if (response.data.code != 200) {
            errorMessage.add(response.data.message)
        }

        if (requestCount.get(location.pathname) == 0 && errorMessage.size > 0) {
            Message.warning(errorMessage.values().next().value)
            errorMessage.clear();
        }

        if (response.data.code === 401) {
            router.push('/login');
        }

        if (response.data.code === 200) {
            return response.data.data;
        }else{
            return null;
        }
    }
    return null;
}, function (error) {
    Message.warning('网络异常，请稍后再试！')
    return Promise.reject(error)
})

export default MyAxios



// WEBPACK FOOTER //
// ./src/utils/request.js